module.exports = function($scope, gettextCatalog, Notification, UserModal, UserModel) {
  this.setCurrentItem = function(user) {
    if (!user) {
      user = {
        firstname: '',
        lastname: '',
        role: 'admin',
        email: '',
        password: '',
      };
    }

    $scope.currentUser = user;
    $scope.backupItem = angular.copy($scope.currentUser);
  };

  $scope.setCurrentItem = this.backupCurrentItem;
  $scope.inputType = 'password';

  $scope.save = function() {
    if (!$scope.currentUser._id) {
      UserModel.save($scope.currentUser, function(error) {
        if (error) {
          Notification.addErrorMessage({ text: error });
        } else {
          Notification.addSuccessMessage(
            gettextCatalog.getString('User "{{currentUser.email}}" added', $scope),
          );
          UserModal.close();
        }
      });
    } else {
      UserModel.update($scope.currentUser, function(error) {
        if (error) {
          Notification.addErrorMessage({ text: error });
        } else {
          Notification.addSuccessMessage(gettextCatalog.getString('User edited'));
          UserModal.close();
        }
      });
    }
  };

  /**
   * delete a customer
   * @param customer
   */
  $scope.delete = function(user) {
    UserModel.delete($scope.currentUser, function(error) {
      if (error) {
        if (error.message == 'cant_delete_last_admin') {
          Notification.addErrorMessage(
            gettextCatalog.getString('One user with admin rights should stay.'),
          );
        } else {
          Notification.addErrorMessage(gettextCatalog.getString('Cant delete user'));
        }
      } else {
        Notification.addSuccessMessage(gettextCatalog.getString('User deleted'));
        UserModal.close();
      }
    });
  };

  $scope.changeInputType = function() {
    if ($scope.showPassword) {
      $scope.inputType = 'text';
    } else {
      $scope.inputType = 'password';
    }
  };

  /**
   * close course modal
   */
  $scope.abort = function() {
    for (var prob in $scope.backupItem) {
      // check if property exists in master data
      if ($scope.currentUser.hasOwnProperty(prob)) {
        $scope.currentUser[prob] = $scope.backupItem[prob];
      }
    }

    UserModal.close();
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/user/userModalCtrl.js